import {Link} from "react-router-dom";
import React from "react";
import {UserMenu} from "../../Header/UserMenu/UserMenu";
import {Row, Col, Button} from "antd";
import {MessageOutlined} from "@ant-design/icons";
import {SelectChatModal} from "../../../views/apps/ai-assistant/SelectChatModal";


export const LogoPart = ({user}) => {

    const [showSelectChatModal, setShowSelectChatModal] = React.useState(false);

    const handleCloseNewChats = () => {
        setShowSelectChatModal(false);
    }

    const handleOpenChats = () => {
        setShowSelectChatModal(true);
    }

    return <Row style={{borderRight: '1px solid #f0f0f0', padding: '10px 20px', borderBottom: '1px solid #f0f0f0'}} align="middle">
        <Col sm={12}><Link to="/view">
            <img src={"/logo.png"} style={{width: '80px'}} alt="logo"/>
        </Link></Col>
        <Col sm={12} style={{textAlign: 'right'}}>
            {/*{showSelectChatModal && <SelectChatModal onClose={handleCloseNewChats}/>}*/}
            {/*<Button icon={<MessageOutlined />} type={"text"} shape={"circle"} onClick={handleOpenChats}/>{' '}*/}
            <UserMenu user={user}/>
        </Col>
    </Row>


}